/* Visionneuse de photos produit (demande d'ANGE, 8/10/2026) : « quand je clique sur zoom, ça zoome énormément et je ne peux pas régler ».
   Au clic, la photo s'ouvre ENTIÈRE à l'écran ; boutons − / + (et molette, pincement sur téléphone, double-clic) pour zoomer par paliers ;
   on déplace la photo en la faisant glisser. S'appuie sur la fenêtre existante <product-modal> du thème. */
(function () {
  var PALIERS = [1, 1.5, 2, 3, 4];
  function init(modal) {
    if (modal.__zoomOk) return; modal.__zoomOk = true;
    var contenu = modal.querySelector('.product-media-modal__content');
    var dialogue = modal.querySelector('.product-media-modal__dialog');
    if (!contenu || !dialogue) return;
    var niveau = 0, zoomLibre = null;
    var barre = document.createElement('div');
    barre.className = 'visionneuse-barre';
    barre.innerHTML = '<button type="button" data-z="-" aria-label="Zoom arrière">−</button><span data-z="val" aria-live="polite">100 %</span><button type="button" data-z="+" aria-label="Zoom avant">+</button>';
    if (!window.matchMedia('(pointer: coarse)').matches) dialogue.appendChild(barre);
    function actif() { return contenu.querySelector('.active') || contenu.querySelector('img'); }
    function base() {
      return Math.max(240, Math.min(contenu.clientWidth, contenu.clientHeight) - 8);
    }
    function appliquer(z, garderCentre) {
      var img = actif(); if (!img) return;
      zoomLibre = z;
      var ancien = { w: contenu.scrollWidth, h: contenu.scrollHeight };
      var cx = (contenu.scrollLeft + contenu.clientWidth / 2) / (ancien.w || 1), cy = (contenu.scrollTop + contenu.clientHeight / 2) / (ancien.h || 1);
      var b = base();
      img.style.width = Math.round(b * z) + 'px'; img.style.maxWidth = 'none'; img.style.height = 'auto';
      if (barre.parentNode) barre.querySelector('[data-z="val"]').textContent = Math.round(z * 100) + ' %';
      contenu.classList.toggle('visionneuse--zoome', z > 1.01);
      if (garderCentre) {
        contenu.scrollLeft = cx * contenu.scrollWidth - contenu.clientWidth / 2;
        contenu.scrollTop = cy * contenu.scrollHeight - contenu.clientHeight / 2;
      } else { contenu.scrollLeft = (contenu.scrollWidth - contenu.clientWidth) / 2; contenu.scrollTop = 0; }
    }
    function palier(n) { niveau = Math.max(0, Math.min(PALIERS.length - 1, n)); appliquer(PALIERS[niveau], true); }
    function reinitialiser() { niveau = 0; appliquer(1, false); }
    barre.addEventListener('click', function (e) {
      var b = e.target.closest('[data-z]'); if (!b) return;
      if (b.dataset.z === '+') palier(niveau + 1); else if (b.dataset.z === '-') palier(niveau - 1);
    });
    contenu.addEventListener('dblclick', function () { if (niveau === 0) palier(2); else reinitialiser(); });
    contenu.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !e.metaKey && niveau === 0 && Math.abs(e.deltaY) < 1) return;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); palier(niveau + (e.deltaY < 0 ? 1 : -1)); }
    }, { passive: false });
    // glisser pour déplacer (souris)
    var glisse = null;
    contenu.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || niveau === 0) return;
      glisse = { x: e.clientX, y: e.clientY, l: contenu.scrollLeft, t: contenu.scrollTop }; contenu.setPointerCapture(e.pointerId); contenu.classList.add('visionneuse--glisse');
    });
    contenu.addEventListener('pointermove', function (e) { if (!glisse) return; contenu.scrollLeft = glisse.l - (e.clientX - glisse.x); contenu.scrollTop = glisse.t - (e.clientY - glisse.y); });
    ['pointerup', 'pointercancel'].forEach(function (n) { contenu.addEventListener(n, function () { glisse = null; contenu.classList.remove('visionneuse--glisse'); }); });
    // téléphone : le pincement à deux doigts est celui du navigateur (comme partout), rien à gérer ici
    // à l'ouverture et au changement de photo : photo entière
    new MutationObserver(function () { if (modal.hasAttribute('open')) setTimeout(reinitialiser, 30); }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    new MutationObserver(function (liste) { if (!modal.hasAttribute('open')) return; if (liste.some(function (m) { return m.target !== contenu && m.target.classList.contains('active'); })) reinitialiser(); }).observe(contenu, { attributes: true, subtree: true, attributeFilter: ['class'] });
    window.addEventListener('resize', function () { if (modal.hasAttribute('open')) appliquer(zoomLibre || 1, true); });
    document.addEventListener('keydown', function (e) { if (!modal.hasAttribute('open')) return; if (e.key === '+' || e.key === '=') palier(niveau + 1); if (e.key === '-') palier(niveau - 1); });
  }
  function demarrer() { document.querySelectorAll('product-modal').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
